import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MasterMakeService } from "../../share/services/master-make/master-make.service";
import { faEdit, faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-tyre-brand-list',
    templateUrl: './tyre-brand-list.component.html',
    styleUrls: ['./tyre-brand-list.component.scss'],
    standalone: false
})
export class TyreBrandListComponent implements OnInit {
  tyreBrandForm: FormGroup;
  showEditMakePopup: boolean = false;
  makeId!: string;
  errorMessage: any;
  makeList: any[] = [];
  addedFields: any[] = [];
  protected faEdit = faEdit;
  protected readonly faPlus = faPlus;
  protected readonly faSearch = faSearch;
  popupType: string;
  readonly subscription: Subscription;
  tyreMakeObj: any = { page: 0 };
  isToster: boolean = false;
  message: any;
  filters: any = {
    page: 0
  }
  isLoading: boolean = false;
  loader: boolean = false;
  endOfResults: boolean = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterMakeService: MasterMakeService,
  ) {
    this.tyreBrandForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      shortName: [[]]
    });
  }

  ngOnInit(): void {
    this.getTyreMake();
  }

  getTyreMake() {
    this.loader = true;
    this.masterMakeService.getTyreMakeDetailsWithNoPagination(this.filters).subscribe({
      next: (res: any) => {
      this.loader = false;
      if (this.filters.page === 0) {
      this.makeList = res.data;
      } else {
        this.makeList = [...this.makeList,...res.data]
      }
      if (res.data.length === 0) {
        this.endOfResults = true;
      }
    },
      error: (error: any) => {
        this.errorMessage = error?.error?.error?.message;
        this.loader = false;
      }
    });

  }

  FilterList(searchTerm: any) {
  this.makeList = [];
  this.filters.page = 0;
  this.filters.searchTerm = searchTerm || '';
  this.getTyreMake();
}

  tyreBrandFormPopup(type: string, list?: any) {
    this.addedFields = [];
    if (type === 'add') {
      this.popupType = 'Add'
      this.showEditMakePopup = true;
    } else {
      this.popupType = 'Update'
      this.makeId = list._id;
      this.tyreBrandForm.patchValue({
        name: list.name,
        shortName: ''
      });
      this.addedFields = list.shortName || [];
      this.showEditMakePopup = true;
    }
  }

  onEditSubmit() {
    this.isLoading = true;
    if (this.popupType === 'Update') {
      const payload = {
        name: this.tyreBrandForm.value.name,
        shortName: this.addedFields
      }
      this.masterMakeService.updateTyreMakeDetails(payload, this.makeId).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.getTyreMake();
        this.closePopup();
        this.isToster = true;
        this.message = res.message;
      },
      error: (error: any) => {
          this.errorMessage = error?.error?.error?.message;
          this.isLoading = false;
        }
    });
    }
    else {
      this.isLoading = true;
      const payload = {
        name: this.tyreBrandForm.value.name,
        shortName: this.addedFields
      }
      this.masterMakeService.saveTyreMake(payload).subscribe({
        next: (res: any) => {
          this.isLoading = false;
          this.getTyreMake();
          this.closePopup();
          this.isToster = true;
          this.message = res.message;
        },
        error: (error: any) => {
          this.errorMessage = error?.error?.error?.message;
          this.isLoading = false;
        }
      });
    }
  }

  closePopup() {
    this.showEditMakePopup = false;
    this.tyreBrandForm.reset();
    this.addedFields = [];
  }

  addData() {
    const shortNameValue = this.tyreBrandForm.controls['shortName'].value;
    if (shortNameValue) {
      this.addedFields.push(shortNameValue.trim()); 
      this.tyreBrandForm.controls['shortName'].reset();
    }
  }

  deleteFieldValues(field: any) {
    this.addedFields = this.addedFields.filter(item => item !== field);
  }

  closeToster(event: any) {
    this.isToster = false;
  }

  loadMore() {
    if (this.endOfResults || this.loader) return;
    this.filters.page++;
    this.getTyreMake();
  }
}
